import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { ref, push, set, onValue, getDatabase } from "firebase/database";
import { ToastContainer, toast } from "react-toastify";

const TimetableForm = () => {
  const [formData, setFormData] = useState({
    teacher: "",
    subject: "",
    class: "",
    division: "",
  });

  const [schoolData1, setSchoolData1] = useState(null);
  const [teachers, setTeachers] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [classes, setClasses] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [abc, setAbc] = useState([]);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [selectedYear, setSelectedYear] = useState("");
  const [uniqueDivisions, setUniqueDivisions] = useState([]); 

  const [teacherAssignments, setTeacherAssignments] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    // Update the formData state
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  

    if (name === "class") {
      setFormData((prevData) => ({ ...prevData, division: "" })); 
      // Update unique divisions based on the selected class
      const selectedClassDivisions = divisions[value] || [];
      setUniqueDivisions([...new Set(selectedClassDivisions)]); 
    }
  };

  useEffect(() => {
    const fetchTeacherData = () => {
      const teacherRef = ref(db, `AttendanceData/${udiseNumber}/AttData`);

      onValue(
        teacherRef,
        (snapshot) => {
          if (snapshot.exists()) {
            const teachersData = snapshot.val();
            const teacherList = [];

            Object.keys(teachersData).forEach((mobileNumber) => {
              const teacher = teachersData[mobileNumber];
              // Access fields exactly as they appear in Firebase
              if (teacher?.Name) {
                teacherList.push({
                  name: teacher.Name,
                  mobile: teacher.Mobno, // Match "Mobno" exactly as in Firebase
                });
              }
            });

            // Extract just names for the dropdown
            setTeachers(teacherList.map((t) => t.name));
            console.log("Fetched teachers:", teacherList); 
          } else {
            console.log("No teacher data found");
          }
        },
        (error) => {
          console.error("Firebase error:", error);
        }
      );
    };

    if (udiseNumber) fetchTeacherData();
  }, [udiseNumber]);

  // Fetch classes
  useEffect(() => {
    const fetchClassData = () => {
      const storedDivClasses = localStorage.getItem("classDiv");
    if (storedDivClasses) {
      const data = JSON.parse(storedDivClasses);
      const classList = [];
      const divisionList = {};
      for (const [className, value] of Object.entries(data)) {
        if (value === true) {
          classList.push(className);
          divisionList[className] = [];
        } else if (typeof value === 'object') {
          classList.push(className);
          divisionList[className] = Object.keys(value).filter(div => value[div]);
        }
      }
      setClasses(classList);
      setDivisions(divisionList);
    };}

    fetchClassData();
  }, [selectedYear, udiseNumber]);


  useEffect(() => {
    if (!udiseNumber) return; // Prevent running if udiseNumber is undefined/null

    const icseRef = ref(db, `schoolRegister/${udiseNumber}/schoolData`);
    const unsubscribe = onValue(icseRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        console.log("data111111111",data.boardType);
        
        setSchoolData1(data.boardType);
      


 
    console.log("schoolData1",data.boardType);
    
    // Determine the correct database path
    const refPath = data.boardType === "icse" || data.boardType === "cbse"
      ? `schoolRegister/${udiseNumber}/teacherAssign/icse`
      : `schoolRegister/${udiseNumber}/teacherAssign`;
  
  
    const dataRef = ref(db, refPath);
  setLoading(false);
    // Listen for changes in thsetLoading(false);e data
    onValue(dataRef, (snapshot) => {
      if (!snapshot.exists()) {
        console.log("No Data Found");
        setAbc([]);
        return;
      }
  
      const data = snapshot.val();
      // console.log("Raw Data:", data);
  
      const formattedData = [];
  
      const processData = (teacher, classes) => {
        console.log("Teacher:", teacher);
  
        Object.entries(classes || {}).forEach(([className, divisions]) => {
          console.log("Class:", className);
  
          Object.entries(divisions || {}).forEach(([division, subjects]) => {
            console.log("Division:", division || "-");

  
            if(typeof(subjects)=== "object"){
              Object.entries(subjects || {}).forEach(([subject, isAssigned]) => {
                console.log("Subject:", subject, "| Assigned:", isAssigned);
    
                // For ICSE: Only add if subject is assigned (true)
                if ((schoolData1 !== "icse" && schoolData1 !== "cbse") || isAssigned === true) {
                  formattedData.push({
                    teacher,
                    class: className,
                    division: division || "-",
                    subject,
                  });
                }
              });
            }
            else{
              formattedData.push({
                teacher,
                class: className,
                subject: division,
              });
            }
           
          });
        });
      };
  
      // Process all teacher assignments
      Object.entries(data).forEach(([teacher, classes]) => processData(teacher, classes));
  
  
      setTeacherAssignments(formattedData);
 
      setAbc(formattedData);
    });
  
  }
});
    return () => unsubscribe(); 
  }, [udiseNumber]);
   


  useEffect(() => {
    if (!udiseNumber || !selectedYear) return;

    let subjectRef;

    if (schoolData1 === "icse" || schoolData1 === "cbse") {
      subjectRef = ref(
        db,
        `schoolRegister/${udiseNumber}/subjectSequence/icse/${selectedYear}`
      );
    } else {
      subjectRef = ref(
        db,
        `schoolRegister/${udiseNumber}/subjectSequence/${selectedYear}`
      );
    }

    onValue(subjectRef, (snapshot) => {
      const data = snapshot.val();

      if (data) {
        let subjectsArray = [];
        let classNames = Object.keys(data); // Extract class names
        let divisionsMap = {}; // Store divisions for each class


        classNames.forEach((className) => {
          let classData = data[className];

          if (typeof classData === "object") {
            let divisions = Object.keys(classData); // Extract division names (sections)
            divisionsMap[className] = divisions; // Store divisions for each class

            console.log(`Divisions for ${className}:`, divisions);

            divisions.forEach((division) => {
              let sectionData = classData[division];

              if (typeof sectionData === "object") {
                Object.values(sectionData).forEach((subject) => {
                  if (subject) {
                    subjectsArray.push(subject);
                  }
                });
              } else if (typeof sectionData === "string") {
                subjectsArray.push(sectionData);
              }
            });
          }
        });

        // setDivisions(divisionsMap); // Set divisions state
        setSubjects(subjectsArray);
        console.log("Filtered Subjects:", subjectsArray);
      } else {
        // setDivisions({});
        setSubjects([]);
      }
    });
  }, [selectedYear, udiseNumber, schoolData1]);



  const handleSubmit = async (e) => {
    e.preventDefault();
  
    console.log("Attempting to submit form with data:", formData);
  
    if (formData.teacher && formData.subject && formData.class) {
      try {
        // Define the path conditionally based on boardType
        const boardTypePath =
          schoolData1 === "icse" || schoolData1 === "cbse"
            ? `schoolRegister/${udiseNumber}/teacherAssign/icse/${formData.teacher}/${formData.class}/${formData.division}/${formData.subject}`
            : `schoolRegister/${udiseNumber}/teacherAssign/${formData.teacher}/${formData.class}/${formData.division}/${formData.subject}`;
  
        const boardTypeRef = ref(db, boardTypePath);
  
        await set(boardTypeRef, true);
  
        setFormData({ teacher: "", subject: "", class: "", division: "" });
  
        toast.success("Data saved successfully!");
        // fetchTableData(); // Refresh the table data after submission
      } catch (error) {
        toast.error("Error saving data!");
        console.error("Error saving data:", error);
      }
    } else {
      toast.error("Please fill in all fields before submitting.");
    }
  };
  



  const getYearOptions = () => {
    const currentYear = 2020;
    const years = [];

    for (let i = 0; i < 10; i++) {
      const year = currentYear + i;
      years.push(`${year}-${String(year + 1)}`);
    }

    return years;
  };



  if (loading) {
    return <div>Loading ...</div>;
  }


  return (
    <div
      className="main-content-of-page"
      style={{
        padding: "90px 40px",
        maxWidth: "90%",
        margin: "auto",
        fontFamily: "Arial, sans-serif",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <ToastContainer />
      <h2
        style={{
          textAlign: "center",
          marginBottom: "20px",
          color: "#333",
          fontFamily: "noto naskh arabic",
        }}
      >
        Assign Class & Subject to Teacher
      </h2>
      <div
        style={{
          background: "#fff",
          width: "50%",
          padding: "20px",
          borderRadius: "10px",
          border: "1px solid black",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", 
        }}
      >
        <form
          onSubmit={handleSubmit}
          style={{ width: "50%", margin: "0 auto" }}
        >
          <div style={{ marginBottom: "15px" }}>
            <label
              style={{
                display: "block",
                fontWeight: "bold",
                marginBottom: "5px",
              }}
            >
              Year:
            </label>
            <select
              name="year"
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid black",
                boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
              }}
            >
              <option value="">Select a Year</option>
              {getYearOptions().map((year, index) => (
                <option key={index} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: "15px" }}>
            <label
              style={{
                display: "block",
                fontWeight: "bold",
                marginBottom: "5px",
              }}
            >
              Teacher:
            </label>
            <select
              name="teacher"
              value={formData.teacher}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid black",
                boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
              }}
            >
              <option value="">Select a Teacher</option>
              {teachers.map((teacherName, index) => (
                <option key={index} value={teacherName}>
                  {teacherName}
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: "15px" }}>
            <label
              style={{
                display: "block",
                fontWeight: "bold",
                marginBottom: "5px",
              }}
            >
              Class:
            </label>
            <select
    name="class"
    value={formData.class} // Ensure this is controlled by formData
    onChange={handleChange}
    style={{
      width: "100%",
      padding: "10px",
      borderRadius: "5px",
      border: "1px solid black",
      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)", // Added box shadow
    }}
  >
    <option value="">Select a Class</option>
    {classes.map((classItem, index) => (
      <option key={index} value={classItem}>
        {classItem}
      </option>
    ))}
  </select>
          </div>
          <div style={{ marginBottom: "15px" }}>
            <label
              style={{
                display: "block",
                fontWeight: "bold",
                marginBottom: "5px",
              }}
            >
              Division:
            </label>
            <select
              name="division"
              value={formData.division}
              onChange={handleChange}
              disabled={!formData.class || uniqueDivisions.length === 0}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid black",
                boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)", 
              }}
            >
               <option value="">Select a Division</option>
    {uniqueDivisions.map((division, index) => (
      <option key={index} value={division}>
        {division}
      </option>
    ))}
  </select>
          </div>
          <div style={{ marginBottom: "15px" }}>
            <label
              style={{
                display: "block",
                fontWeight: "bold",
                marginBottom: "5px",
              }}
            >
              Subject:
            </label>
            <select
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid black",
                boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)", // Added box shadow
              }}
            >
              <option value="">Select a Subject</option>
              {Object.values(subjects)
                .flat()
                .map((subject, index) => (
                  <option key={index} value={subject}>
                    {subject}
                  </option>
                ))}
            </select>
          </div>
          <button
            type="submit"
            style={{
              width: "50%",
              padding: "10px",
              background: "#4CAF50",
              color: "#fff",
              border: "1px solid black",
              borderRadius: "5px",
              boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.3)", // Added box shadow
              cursor: "pointer",
              fontWeight: "bold",
              padding: "10px 20px",

              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              display: "block", // Ensures the button behaves as a block-level element
              margin: "0 auto",
            }}
          >
            Submit
          </button>
        </form>
      </div>

      <h3
        style={{
          marginTop: "30px",
          color: "#333",
          display: "flex",
          justifyContent: "center",
          fontFamily: "emoji",
        }}
      >
        Saved Data
      </h3>
      
<table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "10px",
        background: "#fff",
        border: "1px solid black",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
      }}
    >
      <thead>
        <tr>
          <th
            style={{
              border: "1px solid black",
              padding: "10px",
              textAlign: "center",
              fontWeight: "bold",
              backgroundColor: "#CFE2FF",
            }}
          >
            Teacher
          </th>
          <th
            style={{
              border: "1px solid black",
              padding: "10px",
              textAlign: "center",
              fontWeight: "bold",
              backgroundColor: "#CFE2FF",
            }}
          >
            Class
          </th>
          {(schoolData1 === "icse" || schoolData1 === "cbse") && (
            <th
              style={{
                border: "1px solid black",
                padding: "10px",
                textAlign: "center",
                fontWeight: "bold",
                backgroundColor: "#CFE2FF",
              }}
            >
              Division
            </th>
          )}
          <th
            style={{
              border: "1px solid black",
              padding: "10px",
              textAlign: "center",
              fontWeight: "bold",
              backgroundColor: "#CFE2FF",
            }}
          >
            Subject
          </th>
        </tr>
      </thead>
      <tbody>
        {teacherAssignments.map((row, index) => (
          <tr key={index}>
            <td style={{ border: "1px solid black", padding: "10px" }}>
              {row.teacher}
            </td>
            <td style={{ border: "1px solid black", padding: "10px" }}>
              {row.class}
            </td>
            {(schoolData1 === "icse" || schoolData1 === "cbse") && (
              <td style={{ border: "1px solid black", padding: "10px" }}>
                {row.division || "-"} 
              </td>
            )}
            <td style={{ border: "1px solid black", padding: "10px" }}>
              {row.subject}
            </td>
          </tr>
        ))}
      </tbody>
    </table>

    </div>
  );
};

export default TimetableForm;

